module.exports = __webpack_public_path__ + "0bcf7707ffc8c07922fcbf097ff77daf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/boombox-s.png
// module id = 1992
// module chunks = 0